import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { createPortal } from 'react-dom';
import { ModalContext } from './context';
import { useCloseModalOnEscape, useUpdateBodyClassName } from './hooks';
import { ModalContainer, ModalBackdrop, ModalDialogWrapper, ModalDialogContent } from './styled';
export var ModalDialog = function ModalDialog(_ref) {
  var show = _ref.show,
      onHide = _ref.onHide,
      _ref$rootClose = _ref.rootClose,
      rootClose = _ref$rootClose === void 0 ? true : _ref$rootClose,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'regular' : _ref$size,
      _ref$portalContainer = _ref.portalContainer,
      portalContainer = _ref$portalContainer === void 0 ? document.body : _ref$portalContainer;
  useCloseModalOnEscape(show, onHide);
  useUpdateBodyClassName(show);
  return /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: {
      onHide: onHide
    }
  }, portalContainer && /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(AnimatePresence, {
    "data-test": "animatePresence"
  }, show && /*#__PURE__*/React.createElement(ModalContainer, {
    "data-test": "modal-container"
  }, /*#__PURE__*/React.createElement(ModalBackdrop, {
    "data-test": "modal-backdrop",
    onClick: !rootClose ? undefined : onHide
  }), /*#__PURE__*/React.createElement(ModalDialogWrapper, null, /*#__PURE__*/React.createElement(ModalDialogContent, {
    size: size,
    "data-test": "modal-dialog-content",
    mx: [2, 4, 4],
    overflow: "hidden",
    backgroundColor: "grey.lighter",
    borderRadius: 8,
    flexDirection: "column"
  }, children)))), portalContainer));
};